import { ICreatorInfo, IContextInfo } from '@umu/umu-types';
import { safeJSONParse } from 'businessCommon/src/@utils/jsonParse';

/**
 * @description 增加强类型之后的模板方法 , 这个文件定位于整个application。不要随便动这个地方。
 * @author duanjun
 */

import './pollify';
import { $document, $window, getQueryString } from '@umu/umu-dom';

interface IWxJsConfig {
    appid: string;
    noncestr: string;
    signature: string;
    timestamp: number;
    url: string;
}

interface ITemplateVariableConfig {
    env: string;
    fixed: boolean;
    lang: string;
    site_host: string;
    step_length: number;
    system: string;
    wxJsConfig?: IWxJsConfig;
    page_token?: string;
    pay_channel?: string[];
    contextInfo?: IContextInfo;
    creatorInfo?: ICreatorInfo;
    skey?: string;
    is_course_mini_app: boolean;
}

interface ITemplateVariable {
    config: ITemplateVariableConfig;
    errno: number;
    error: string;
    page_token: string;
    status: boolean;
    [prop: string]: any;
}

export default class Application<T = {}> {
    /**
     * @description 暂时和页面模板变量保持一致。后面在差异返回
     */
    public static getModuleTemplateData() {
        // 保证只能用一次, 使命完成即销毁
        if (Application.moduleTemplateData === null) {
            throw new Error('getModuleTemplateData Error!!!');
        }
        setTimeout(() => {
            Application.moduleTemplateData = null;
        });
        return Application.moduleTemplateData as ITemplateVariable;
    }

    public static getTemplateData() {
        // 保证只能用一次, 使命完成即销毁
        if (Application.pageTemplateData === null) {
            throw new Error('getTemplateData Error!!!');
        }
        setTimeout(() => {
            Application.pageTemplateData = null;
        });
        return Application.pageTemplateData as ITemplateVariable;
    }

    private static pageTemplateData: ITemplateVariable | null = Application.init() as ITemplateVariable | null;
    private static moduleTemplateData: ITemplateVariable | null = Application.init() as ITemplateVariable | null;

    private static initWx(wxJsConfig: IWxJsConfig) {
        if (typeof wx !== 'undefined' && wx.config) {
            const isDebugWx = getQueryString('isDebugWx') == '1';
            wx.config({
                debug: isDebugWx,
                appId: wxJsConfig.appid,
                timestamp: wxJsConfig.timestamp,
                nonceStr: wxJsConfig.noncestr,
                signature: wxJsConfig.signature,
                jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'chooseImage',
                    'uploadImage',
                    'downloadImage',
                    'startRecord',
                    'stopRecord',
                    'onVoiceRecordEnd',
                    'onVoicePlayEnd',
                    'playVoice',
                    'stopVoice',
                    'pauseVoice',
                    'uploadVoice',
                ],
                // @ts-ignore
                openTagList: ['wx-open-launch-weapp'],
            });
        }
    }

    private static init() {
        try {
            const template = $document.getElementById('__pageDataTemplate__');
            if (template) {
                try {
                    const templateData = safeJSONParse(template.innerText.trim(), {} as ITemplateVariable);
                    const config = templateData.config;

                    if (config && config.wxJsConfig) {
                        Application.initWx(config.wxJsConfig);
                    }

                    return templateData;
                } catch (parseError) {
                    console.error('Failed to parse page template data', parseError, template.innerText.trim());
                    $window.alert(`PageData parse Error!!! ${JSON.stringify(parseError)}`);
                }
            }
            return {} as ITemplateVariable;
        } catch (e) {
            $window.alert(`PageData init Error!!! ${JSON.stringify(e)}`);
            return {} as ITemplateVariable;
        }
    }

    constructor(private data: T) {}

    public getData: ConstTypedExtractor<T> = (...keys: Array<string | number>) => {
        if (keys.length === 0) {
            return this.data;
        }
        let result: any = this.data;
        keys.forEach((key) => {
            if (result !== undefined && result !== null) {
                result = result[key];
            }
        });
        return result;
    };
}
